module.exports = __webpack_public_path__ + "7be88e73fea7b64568a450d7c01346b0.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/BoldItalic/OpenSans-BoldItalic.woff?v=1.1.0
// module id = 1009
// module chunks = 0